var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.1,0.1c-6.6,0-12,5.4-12,12.1s5.4,12.1,12,12.1s12-5.4,12-12.1c0-3.2-1.3-6.3-3.5-8.6S15.3,0.1,12.1,0.1z  M12.1,22.2c-5.5,0-10-4.5-10-10.1S6.6,2,12.1,2s10,4.5,10,10.1S17.6,22.2,12.1,22.2z M16.1,9.6c0,0.8-0.1,1.5-0.5,2.2 c-0.4,0.5-0.9,0.9-1.5,1.1c-0.3,0.1-1,0.4-2.1,0.7c-0.4,0.1-0.8,0.2-1.1,0.4c-0.2,0.1-0.4,0.2-0.5,0.4c-0.2,0.4-0.3,0.8-0.2,1.2v0.8 h6v1.8h-8v-3C8,14.4,8.3,13.6,8.8,13c0.5-0.5,1.1-0.8,1.8-1l2.2-0.6c0.4-0.1,0.8-0.3,1.1-0.6c0.2-0.3,0.3-0.7,0.2-1 c0-0.3,0-0.6-0.1-0.9c-0.1-0.2-0.2-0.4-0.4-0.6c-0.5-0.2-1-0.3-1.5-0.3c-0.5-0.1-1.1,0-1.6,0.3c-0.3,0.2-0.4,0.6-0.4,0.9h-2 C8,8,8.5,7,9.4,6.5C10.2,6.1,11.1,5.9,12,6c1.1-0.1,2.3,0.2,3.2,0.9C15.9,7.7,16.2,8.6,16.1,9.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoStep2);
export default __webpack_public_path__ + "static/media/ico-step2.e057201c266f0f8433da479d807c4374.svg";
export { ForwardRef as ReactComponent };